import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, ArrowUpRight, Brain, Globe, Palette, Image, MessageSquare, BarChart3, Mail, Inbox as InboxIcon, Megaphone, Film, ShieldCheck, Link2 } from "lucide-react";

const ALL = [
  { icon: Brain, title: "AI Business Analysis", desc: "SWOT, personas, marketing strategy, SEO strategy, 90-day roadmap." },
  { icon: Globe, title: "AI Website Builder", desc: "Hero, features, services, testimonials, FAQ, contact — fully generated." },
  { icon: Palette, title: "AI Brand Identity", desc: "Logo, color palette, typography, voice, mission, story, tagline." },
  { icon: Image, title: "AI Logo Studio", desc: "Premium logo concepts. Storage-backed. One-click viral share page." },
  { icon: Megaphone, title: "AI Content Studio", desc: "Posts for Instagram, Facebook, LinkedIn, X, Threads + blogs." },
  { icon: Film, title: "AI Video & Creatives", desc: "Reel scripts, shorts, ad creatives, festival posts, story banners." },
  { icon: Mail, title: "Email & WhatsApp Campaigns", desc: "AI-written, queued, delivered with metrics." },
  { icon: InboxIcon, title: "AI Reply Inbox", desc: "Drafts brand-voiced replies for comments, reviews, DMs across 5 channels." },
  { icon: Link2, title: "Social Connections", desc: "Instagram, Facebook, LinkedIn, X, Google, YouTube, Threads, Pinterest." },
  { icon: BarChart3, title: "Analytics & Insights", desc: "Reach, engagement, traffic, channel mix, AI growth suggestions." },
  { icon: ShieldCheck, title: "Approval Workflow", desc: "AI drafts, you approve. Sensitive content auto-escalates to humans." },
  { icon: MessageSquare, title: "Support & White-label", desc: "Support tickets, role hierarchy, agency white-label, public APIs (soon)." },
];

export default function Features() {
  return (
    <div className="min-h-screen bg-[#05050A] text-white grid-bg p-6 lg:p-12" data-testid="features-root">
      <div className="max-w-6xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-10">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-2 mb-10">
          <div className="h-9 w-9 rounded-lg brand-gradient grid place-items-center">
            <Sparkles className="h-5 w-5" />
          </div>
          <span className="font-heading font-black text-lg tracking-tight">
            MakeYour<span className="brand-gradient-text">Brand.IN</span>
          </span>
        </div>

        <div className="text-xs uppercase tracking-[0.25em] text-orange-400/80 mb-3">Features</div>
        <h1 className="font-heading text-4xl lg:text-6xl font-black tracking-tighter mb-4 max-w-3xl">
          Twelve AI modules. <br />One marketing team replaced.
        </h1>
        <p className="text-white/60 mt-4 max-w-2xl">
          Every module is built to work autonomously — and gracefully hand off to humans for the messy 5% of cases that need judgment.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12">
          {ALL.map((f) => (
            <div key={f.title} className="glass rounded-2xl p-6 hover:bg-white/5 transition-all duration-300 hover:-translate-y-1 hover:border-orange-500/30">
              <div className="h-10 w-10 rounded-lg brand-gradient grid place-items-center mb-4">
                <f.icon className="h-5 w-5" />
              </div>
              <h3 className="font-heading font-bold text-lg tracking-tight">{f.title}</h3>
              <p className="text-sm text-white/60 mt-2 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <Link to="/register" className="inline-flex items-center gap-2 brand-gradient px-6 py-3.5 rounded-lg text-sm font-semibold hover:opacity-90 glow-orange">
            Start your free trial <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
